import React from 'react';
import { useTranslation } from 'react-i18next';

export const SeeMoreButton = ({ onClick, isMobile = false }) => {
  const { t } = useTranslation('common');

  return (
    <div className="flex justify-center">
      <button
        type="button"
        className={`px-${isMobile ? '4' : '3'} py-2 bg-white rounded-md text-sm font-medium ${
          isMobile ? 'hover:bg-blue-50 transition-colors border border-blue-200' : 'transition-colors border'
        } w-fit ${isMobile ? 'self-center' : ''} shadow-sm ${isMobile ? 'md:hidden' : ''}`}
        onClick={onClick}
      >
        {t('buttons.seeMore')}
      </button>
    </div>
  );
};
